//REDUX-TOOLKIT
import { createSlice, PayloadAction } from "@reduxjs/toolkit"

interface State {
    countries: any
    storesUrl: any
    wikiUrl: any
    exchangeInfo: any
    XPLUSDT: any
    isConvertedPriceLoading: boolean
}

const initialState: State = {
    countries: null,
    storesUrl: null,
    wikiUrl: null,
    exchangeInfo: {
        name: "",
        url: "",
    },
    XPLUSDT: null,
    isConvertedPriceLoading: false,
}

const slice = createSlice({
    name: "utils",
    initialState,
    reducers: {
        setCountries: (state, action: PayloadAction<any>) => {
            return { ...state, countries: action.payload }
        },
        setStoresUrl: (state, action: PayloadAction<any>) => {
            return { ...state, storesUrl: action.payload }
        },
        setWikiUrl: (state, action: PayloadAction<any>) => {
            return { ...state, wikiUrl: action.payload }
        },
        setExchangeInfo: (state, action: PayloadAction<any>) => {
            return { ...state, exchangeInfo: action.payload }
        },
        setConversionRate: (state, action: PayloadAction<any>) => {
            return { ...state, XPLUSDT: action.payload }
        },
        setIsConvertedPriceLoading: (state, action: PayloadAction<boolean>) => {
            return {
                ...state,
                isConvertedPriceLoading: action.payload,
            }
        },
    },
})

export const {
    setCountries,
    setStoresUrl,
    setWikiUrl,
    setExchangeInfo,
    setConversionRate,
    setIsConvertedPriceLoading,
} = slice.actions
export const selectUtils = (state: { utils: State }) => state.utils
export default slice.reducer
